// component
import SvgColor from "../../../components/svg-color/SvgColor";
// import Iconify from 'src/components/svg-color/SvgColor';
// ----------------------------------------------------------------------

const getIcon = (name) => <SvgColor icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: getIcon('mdi:monitor-dashboard'),
  },
  {
    title: 'Seller',
    path: '/dashboard/seller',
    icon: getIcon('mdi:shop-check'),


  },
  {
    title: 'Menu',
    path: '/dashboard/products',
    icon: getIcon('material-symbols:menu-book'),

  },
  {
    title: 'User',
    path: '/dashboard/user',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'Ordars',
    path: '/dashboard/ordar',
    icon: getIcon('material-symbols:order-approve'),
  }, {
    title: 'Delivery',
    path: '/dashboard/deliver',
    icon: getIcon('mdi:delivery-dining'),

  },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon('ri:login-box-fill'),

  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  // },
];

export default navConfig;
